import { writable } from "svelte/store";

const stored_refresh = localStorage.getItem("refresh");
export const refresh = writable(stored_refresh);

refresh.subscribe(value => {
    console.log(value)
    localStorage.setItem("refresh", value ? value : "0");
});